"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationResponse = (function () {
    function AuthenticationResponse(options) {
        this.status = options.status;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    return AuthenticationResponse;
}());
exports.AuthenticationResponse = AuthenticationResponse;
var ErrorResponse = (function () {
    function ErrorResponse(options) {
        this.status = options.status;
        this.headers = options.headers || {};
        this.error = options.error;
        this.error_description = options.error_description;
        this.error_uri = options.error_uri;
    }
    return ErrorResponse;
}());
exports.ErrorResponse = ErrorResponse;
//# sourceMappingURL=common.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pusher-platform-node/target/common.js
// module id = 185
// module chunks = 0